import {
  FDLabelText,
  FDStack,
  FDTitleText,
  FDBodyText,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import BlockItem from 'Views/Page/Content/Modal/Layouts/PlannerGuideLayout/Layout/components/BlockItem';

const blockItemMetaOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDLabelText,
  }, { ordinal: 200 })
  .nameOverride('description', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, { ordinal: 200 })
  .nameOverride('examples', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, { ordinal: 200 });


const BlockItems = ({ title, items }) => {
  return (
    <FDStack direction={'column'} spacing={2}>
      {title ? <FDTitleText size={'lg'} value={title} /> : null}
      <FDStack direction={'row'} spacing={3} wrap justifyContent={'space-between'}>
        {items.map(blockItem => {
          return (
            <MetaResourceRenderer
              resource={blockItem}
              layout={BlockItem}
              metaOverrideSet={blockItemMetaOverride}
            />
          );
        })}
      </FDStack>
    </FDStack>
  );
};

BlockItems.defaultProps = {
  title: '',
};

BlockItems.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(fr.Resource).isRequired,
};

export default BlockItems;
